var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorder1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 220,
    viewBox: "0 0 385 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.5 213.8H381.5V219.8H384.5V213.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384.5 201.7H381.5V189.6H384.5V201.7ZM384.5 177.4H381.5V165.3H384.5V177.4ZM384.5 153.1H381.5V141H384.5V153.1ZM384.5 128.8H381.5V116.7H384.5V128.8ZM384.5 104.6H381.5V92.5H384.5V104.6ZM384.5 80.3H381.5V68.2H384.5V80.3ZM384.5 56H381.5V43.9H384.5V56ZM384.5 31.7H381.5V19.6H384.5V31.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.5 7.5H381.5V3H377V0H384.5V7.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365.1 3H353.1V0H365.1V3ZM341.1 3H329.1V0H341.1V3ZM317.2 3H305.2V0H317.2V3ZM293.3 3H281.3V0H293.3V3ZM269.3 3H257.3V0H269.3V3ZM245.4 3H233.4V0H245.4V3ZM221.4 3H209.4V0H221.4V3ZM197.5 3H185.5V0H197.5V3ZM173.6 3H161.6V0H173.6V3ZM149.6 3H137.6V0H149.6V3ZM125.7 3H113.7V0H125.7V3ZM101.8 3H89.8V0H101.8V3ZM77.8 3H65.8V0H77.8V3ZM53.9 3H41.9V0H53.9V3ZM29.9 3H18V0H30V3H29.9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0H0V3H6V0Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder1);
export default __webpack_public_path__ + "static/media/border-1.fbb293bbba0fd983e24aee19a90b106e.svg";
export { ForwardRef as ReactComponent };